import { Link } from "react-router-dom";

export const Loading = () => (
  <div className="container-site py-24" role="status" aria-live="polite" data-testid="page-loading">
    <div className="h-10 w-2/3 max-w-xl rounded-full bg-cream-deep animate-pulse" />
    <div className="mt-6 h-5 w-full max-w-2xl rounded-full bg-cream-deep animate-pulse" />
    <div className="mt-3 h-5 w-5/6 max-w-xl rounded-full bg-cream-deep animate-pulse" />
    <span className="sr-only">Loading</span>
  </div>
);

export const NotFoundBlock = ({ title = "We couldn't find that page." }) => (
  <div className="container-site py-24 max-w-2xl" data-testid="not-found">
    <h1 className="text-4xl sm:text-5xl">{title}</h1>
    <p className="mt-5 text-ink-soft text-lg">It may have moved or been updated. You can start again from the homepage, or find guidance that fits your situation.</p>
    <div className="mt-8 flex flex-wrap gap-3">
      <Link to="/" className="btn-primary" data-testid="not-found-home-btn">Go to the homepage</Link>
      <Link to="/find-your-way" className="btn-secondary">Find your way</Link>
    </div>
  </div>
);
